/* eslint-disable no-undef */
import { useMemo, useState } from "react";
import environment from "@/enviroments/enviroment";

import { base64ToText, isBase64 } from "@/utils/base64";

function toJSON(value) {
  if (isBase64(value)) {
    value = base64ToText(value);
  }

  return JSON.parse(value);
}

function getValue(name, options = {}) {
  const { defaultValue = null, callback = null } = options;

  if (!environment[name]) {
    return defaultValue;
  }

  const value = environment[name];

  if (callback instanceof Function) {
    return callback(value);
  }

  const buffer = Number(value);

  if (!isNaN(buffer)) {
    return buffer;
  }

  return value;
}

function getParams(value) {
  let name = value;
  let defaultValue = null;

  if (name instanceof Array) {
    [name, defaultValue] = name;
  }

  const index = name.replace(/[\w:]/g, "");
  name = name.replace(/[^\w:]/g, "");
  let alias = name;
  const pos = name.indexOf(":");

  if (pos !== -1) {
    alias = name.substring(pos + 1);
    name = name.substring(0, pos);
  }

  const indexs = {
    "%": toJSON,
  };
  const callback = indexs[index];

  return {
    name,
    alias,
    options: {
      defaultValue,
      callback,
    },
  };
}

function useSettings(items, props = {}) {
  const [settings, setSettings] = useState({});

  useMemo(() => {
    let options = {};

    items.forEach((item) => {
      const params = getParams(item);
      const value = getValue(params.name, params.options);

      if (value !== null) {
        options[params.alias] = value;
      }
    });

    setSettings({
      ...options,
      ...props,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [settings, setSettings];
}

export default useSettings;
